module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md4": "",
      "text-xs-center": ""
    }
  }, [_c('button-slide-list', {
    attrs: {
      "tabindex": "0",
      "id": "menu-lista",
      "aria-label": _vm.nombreLista,
      "botsNames": _vm.bots
    },
    on: {
      "currentBot": _vm.currentBot
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "unstyled-focus",
    attrs: {
      "tabindex": "0",
      "id": "contenidos",
      "aria-label": 'Contenido ' + _vm.bots[_vm.nombreCurrentBot].name
    }
  }), _c('br'), _vm._v(" "), _vm._l((_vm.bots), function(item, index) {
    return (_vm.contenido === (index + 1)) ? _c('div', {
      key: 'slide-cont' + index
    }, [_vm._t('cont-' + index)], 2) : _vm._e()
  }), _vm._v(" "), (!_vm.finContenidos) ? _c('button', {
    attrs: {
      "aria-label": "Volver a la lista anterior"
    },
    on: {
      "click": function($event) {
        _vm.backMenu()
      }
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5694f3a1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/tabsButtonsSlide.vue
// module id = 990
// module chunks = 1